import { Component, Inject, OnInit } from '@angular/core';
import { Router, NavigationStart} from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';

import { OktaAuth } from '@okta/okta-auth-js';
import * as OktaSignIn from '@okta/okta-signin-widget';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-secure',
  template: `
    <!-- Container to inject the Sign-In Widget -->
    <div id="okta-signin-container"></div>
  `,
  standalone: false
})
export class LoginComponent implements OnInit {
  authService;
  widget = new (OktaSignIn as any)({
    el: '#okta-signin-container',
    baseUrl: environment.baseUrl,
    clientId: environment.clientId,
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.postLogoutRedirectUri,
    authParams: {
      pkce: true,
      responseMode: 'query',
    }
  });

  constructor(@Inject(OKTA_AUTH) oktaAuth: OktaAuth, readonly router: Router) {
    this.authService  = oktaAuth;

    // Show the widget when prompted, otherwise remove it from the DOM.
    router.events.forEach(event => {
      if (event instanceof NavigationStart) {
        switch(event.url) {
          case '/login':
            break;
          case '/home':
            break;
          default:
            this.widget.remove();
            break;
        }
      }
    });
  }

  ngOnInit() {
    this.widget.renderEl({
      el: '#okta-signin-container'},
      (res: any) => {
        if (res.status === 'SUCCESS') {          
          this.authService.signInWithRedirect({originalUri: '/home',  sessionToken: res.session.token });
          this.widget.hide();
        }
      },
      (err: any) => {
        throw err;
      }
    );
  }
}